// Route segments of the client-file ("Kundenakt") areas, shared by both apps: the internal app
// mounts them under /clients/:id/debt-settlement/..., the external portal under /portal/kundenakt/....
// Shared navigation components build links from ClientFileContext.basePaths + these segments, so
// neither app's routing model leaks into shared code. The internal app's ClientRoutes re-exports
// these enums under their historical names (AssetInventorySubTab, BankruptcyChecklistSubTab).

export enum AssetInventorySection {
  PersonalData = "personal-data",
  Relatives = "relatives",
  Income = "income",
  Expenses = "expenses",
  OwnClaims = "own-claims",
  Assets = "assets",
  OtherPropertyRights = "other-property-rights",
  Donations = "donations",
  /** Documents overview — rendered by the internal app only (the portal has no documents section). */
  Documents = "documents",
}

export enum BankruptcyChecklistSection {
  DangerousDebts = "dangerous-debts",
  SpecialDebts = "special-debts",
  BankruptcyCapability = "bankruptcy-capability",
  BankruptcyConsequences = "bankruptcy-consequences",
}
